<template>
  <div>
    <v-row justify="center">
      <v-col md="5">
        <Tabla
          modulo="diagnosticos"
          nuevoTxt="Nuevo Diagnostico"
          propId="IdProblema"
          propDescripcion="Problema"
          singular="Diagnostico"
        ></Tabla>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Tabla from "@/components/ABM/TablaPaginada";
import { mapActions } from "vuex";

export default {
  name: "Diagnosticos",
  components: {
    Tabla,
  },
  methods: {
    ...mapActions("diagnosticos", ["set"]),
  },
  mounted() {
    this.set();
  },
};
</script>
<style></style>
